import { render, staticRenderFns } from "./VirtualOption.ts.vue?vue&type=template&id=7be8f0b2&"
import script from "./VirtualOption.ts.vue?vue&type=script&lang=ts&"
export * from "./VirtualOption.ts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports